/* @flow */

import featureRouter from 'src/shared/app/feature/featureRouter';
import { createFeatureDecisions } from 'src/shared/app/feature/factory/featureFactory';

export default function useFeatureDecisions() {
  const obj = createFeatureDecisions(featureRouter);

  return {
    isSelfCheckInEnabled: obj.isSelfCheckInEnabled(),
    isHelpEnabled: obj.isHelpEnabled(),
    isSlackIntegrationEnabled: obj.isSlackIntegrationEnabled(),
    areEmailNotificationsEnabled: obj.areEmailNotificationsEnabled(),
    isNotificationPromptShown: obj.isNotificationPromptShown(),
    isSignupEnabled: obj.isSignupEnabled(),
    isVideoCallEnabled: obj.isVideoCallEnabled(),
    useLightTheme: obj.useLightTheme(),
    isModerationEnabled: obj.isModerationEnabled(),
    isRecommendedUserEnabled: obj.isRecommendedUserEnabled(),
    isConversationFormatEnabled: obj.isConversationFormatEnabled(),
    isFishbowlHotSeatEnabled: obj.isFishbowlHotSeatEnabled(),
    isCustomFontEnabled: obj.isCustomFontEnabled(),
    isFishbowlEnabled: obj.isFishbowlEnabled(),
    isCustomMenuEnabled: obj.hasCustomMenu(),
    isProvideFeedbackSectionEnabled: obj.isProvideFeedbackSectionEnabled(),
    isInterestBasedBraindatingEnabled: obj.isInterestBasedBraindatingEnabled(),
    isTrendingKeywordsSectionEnabled: obj.isTrendingKeywordsSectionEnabled(),
    isVirtualBraindateRecordingsEnabled:
      obj.isVirtualBraindateRecordingsEnabled(),
    isAccessibilityCompatibleEnabled: obj.isAccessibilityCompatibleEnabled(),
    isTranscribeFeatureEnabled: obj.isTranscribeFeatureEnabled(),
    isRecommendationFeatureEnabled: obj.isRecommendationFeatureEnabled(),
    isExpressionOfGratitudeEnabled: obj.isExpressionOfGratitudeEnabled(),
    isUserOnboardingFeatureEnabled: obj.isUserOnboardingFeatureEnabled(),
    isGroupMessageModalEnabled: obj.isGroupMessageModalEnabled(),
  };
}
